import { BKJCenteredDialog } from 'components/BKJCenteredDialog';
import { RemoveCustomerLocationDialogProps } from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/RemoveCustomerLocationDialog/RemoveCustomerLocationDialog.types';
import {
  RemoveCustomerLocationDialogFormProvider,
  useRemoveCustomerLocationDialogFormContext,
} from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/RemoveCustomerLocationDialog/RemoveCustomerLocationDialog.form.context';
import { FC } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { isNewLocationId } from '../CustomersSettingsPage.constants';

const RemoveCustomerLocationDialogView: FC<RemoveCustomerLocationDialogProps> = ({
  isRemoveCustomerLocationConfirmationOpen,
  setIsRemoveCustomerLocationConfirmationOpen,
  locationName,
  addressId,
}) => {
  const { t } = useTranslation();
  const { handleRemoveCustomerLocation } = useRemoveCustomerLocationDialogFormContext();

  const isNewLocation = isNewLocationId(addressId);

  let text: string;
  let title: string;

  if (isNewLocation) {
    title = t('location_settings:DELETE_LOCATION_TITLE');
    text = t('location_settings:DELETE_LOCATION_MESSAGE');
  } else {
    title = t('location_settings:REMOVE_CUSTOMER_LOCATION_TITLE');
    text = t('location_settings:REMOVE_CUSTOMER_LOCATION_MESSAGE');
  }

  return (
    <BKJCenteredDialog
      isOpen={isRemoveCustomerLocationConfirmationOpen}
      variant="Default"
      title={title}
      text={text}
      cancelLabel={t('auth:CANCEL')}
      actionLabel={t('shift_modal:CONTINUE')}
      onAction={() => {
        setIsRemoveCustomerLocationConfirmationOpen(false);
        return handleRemoveCustomerLocation();
      }}
      onCancel={() => setIsRemoveCustomerLocationConfirmationOpen(false)}
      onClose={() => setIsRemoveCustomerLocationConfirmationOpen(false)}
    />
  );
};

export const RemoveCustomerLocationDialog: FC<RemoveCustomerLocationDialogProps> = (props) => {
  return (
    <RemoveCustomerLocationDialogFormProvider {...props}>
      <RemoveCustomerLocationDialogView {...props} />
    </RemoveCustomerLocationDialogFormProvider>
  );
};
